import r from "./sequiter-image.vue2.js";
import { openBlock as t, createElementBlock as m, mergeProps as n } from "vue";
import "./sequiter-image.vue3.js";
import p from "../../_virtual/_plugin-vue_export-helper.js";
function a(e, o, s, i, f, d) {
  return t(), m("img", n({
    class: e.$options.name
  }, e.imageObj, {
    onLoad: o[0] || (o[0] = (l) => e.$emit("load"))
  }), null, 16);
}
const g = /* @__PURE__ */ p(r, [["render", a], ["__scopeId", "data-v-b144f6eb"]]);
export {
  g as default
};
//# sourceMappingURL=sequiter-image.vue.js.map
